import { render, staticRenderFns } from "./SearchWeightEdit.vue?vue&type=template&id=3af0dd94&scoped=true&"
import script from "./SearchWeightEdit.vue?vue&type=script&lang=js&"
export * from "./SearchWeightEdit.vue?vue&type=script&lang=js&"
import style0 from "./SearchWeightEdit.vue?vue&type=style&index=0&id=3af0dd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0dd94",
  null
  
)

export default component.exports